/** 
 * Enables or disables swiper based on the viewport size and number of slider items
 * @param {String} sliderContainer - slider container class name
 * @param {number} numOfItemsWhenDisabled - number of slider items when swiper is disabled
 * @param {String} effect - swiper effect. 'fade' or null.
 * @param {String} width - pass the string "full" to break out the page margins. 
 * Otherwise pass null.
*/

// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, A11y, EffectFade } from "swiper/modules";

const sliderLayoutController = (sliderContainerClass, numOfItemsWhenDisabled, effect = null, width = null, prevBtn = ".swiper-button-prev", nextBtn = ".swiper-button-next") => {
	const sliderContainers = Array.from(document.getElementsByClassName(sliderContainerClass));
	// need to check if we are on desktop or not to disable or enable swiper
	const breakpoint = window.matchMedia( '(min-width: 768px)' );

	const getEffect = (effect) => {
		if (!effect) return {};

		if (effect === 'fade') {
			return {
				effect: "fade",
				fadeEffect: {           
					crossFade: true,
				},
				breakpoints: {
					375: {
						effect: "fade",
						fadeEffect: {           
							crossFade: true,
						},
					}
				}
			}
		}
	}

	const getWidth = (width) => {
		if (!width) return {};

		if (width === 'full' && effect !== 'fade') {
			return {
				slidesOffsetBefore: 25,
				slidesOffsetAfter: 25,
				breakpoints: {
					768: {
						slidesOffsetBefore: 0,
						slidesOffsetAfter: 0,
					},
					1024: {
						slidesOffsetBefore: 0,
						slidesOffsetAfter: 0,
						spaceBetween: 40,		
					}
				}
			}
		}
	}

	const addConfig = (swiperConfig, effectConfig, widthConfig) => {
		return {...swiperConfig, ...effectConfig, ...widthConfig};
	}
	
	if (sliderContainers.length > 0) {
		
		sliderContainers.forEach(slider => {
			const numOfSlideItems =  slider.getElementsByClassName('swiper-slide').length;
			const slidesPerView = effect === 'fade' ? 1 : 'auto';
			// disable swiper if on desktop and when it has less than or equal to specified number of items
			let disabled = (numOfSlideItems <= numOfItemsWhenDisabled && breakpoint.matches === true) || (numOfSlideItems === 1);

			// base swiper configs
			const swiperConfig = {
				modules: [Navigation, A11y, EffectFade],
				a11y: {
					prevSlideMessage: "Previous slide",
					nextSlideMessage: "Next slide",
				},
				navigation: {
					prevEl: prevBtn,
					nextEl: nextBtn,
				},
				speed: 600,
				spaceBetween: 20,
				slidesPerView: slidesPerView,
				breakpoints: {
					768: {
						slidesPerView: slidesPerView,
					},
					1024: {
						slidesPerView: slidesPerView,
					}
				}
			};

			let mySwiper;
			// add the "fade" effect to the swiper config if specified
			const newSwiperConfig = addConfig(swiperConfig, getEffect(effect), getWidth(width));

			const enableSwiper = function() {
				// create new instance of the Swiper slider
				// eslint-disable-next-line no-unused-vars
				mySwiper = new Swiper(slider, newSwiperConfig);
			}
    
			const itemsChecker = function() {
				// swiper will be disabled at the specified number of slider items on desktop
				disabled = (numOfSlideItems <= numOfItemsWhenDisabled && breakpoint.matches === true) || (numOfSlideItems === 1);

				if ( disabled ) {
					// disable swiper if it is initialized
					if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
				} else {
					// otherwise enable swiper
					enableSwiper();
				}
			};
            
			// checking on page load for number of items and viewport width to disable or enable swiper
			itemsChecker();

			// keep an eye on viewport size changes
			breakpoint.addEventListener('change', itemsChecker);
		});
	}
}

export default sliderLayoutController;